export const API_ENV = window.environment.API_ENV;
const API_ENV_URLS = {
    local: "http://localhost:3000/local",
    stg: "https://oogx4k12f4.execute-api.us-east-1.amazonaws.com/stg",
    //oldprod: "https://e6tr9v2x33.execute-api.us-east-1.amazonaws.com/dev",
    production: "https://sb1qr7fi64.execute-api.us-east-1.amazonaws.com/prod",
};
export const API_URL = API_ENV_URLS[API_ENV] || API_ENV_URLS["production"];
// later for staging, we have different application id 6bc15e61-927b-4be0-8789-8112023487c0
/*
["stg", "local"].includes(API_ENV)
    ? "6bc15e61-927b-4be0-8789-8112023487c0"
    : "d4f6c9c6-8055-45f3-b583-5bb66983afdc";
*/
export const MICROSOFT_CLIENT_ID = "d4f6c9c6-8055-45f3-b583-5bb66983afdc";
export const MICROSOFT_GROUP_ID = "b6178fab-b5e3-4deb-b8f6-448c4d6535f3";
